module.exports = __webpack_public_path__ + "img/banner_auth.e96be449.jpg";